// CompanyChip.jsx — 회사 색 칸 (통합 관리 홈 요약·목록 공용, 2026-10-01). 색은 integratedFeatureMeta 한 곳.
//   2026-10-15: 글자 = 작업 대상과 같은 회사 이름(유기자차·무기자차) — 색은 그대로 코드로 정한다.
import React from 'react';
import { companyColor } from '../integratedmenu/integratedFeatureMeta';
import { useCompanyNames } from '../adminlayout/useCompanyNames';

export default function CompanyChip({ code, small = false }) {
  const col = companyColor(code);
  const nameOf = useCompanyNames();
  return (
    <span
      className={small
        ? 'rounded-[5px] px-[7px] py-[3px] text-[10px] font-black leading-none'
        : 'rounded-md px-2.5 py-1 text-[12px] font-black leading-none'}
      style={{ background: col.bg, color: col.fg }}
    >
      {nameOf(code)}
    </span>
  );
}
